var _style, _path, _path2, _path3, _circle, _path4, _path5, _path6, _circle2, _circle3, _path7, _circle4, _circle5, _circle6, _text, _text2, _text3, _text4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBehav(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 327 313.2",
    style: {
      enableBackground: "new 0 0 327 313.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#00857A;}\r\n\t.st1{fill:#C4ECE9;}\r\n\t.st2{fill:#FED0D4;}\r\n\t.st3{fill:#129C90;}\r\n\t.st4{fill:none;stroke:#129C90;}\r\n\t.st5{fill:none;stroke:#E22336;}\r\n\t.st6{fill:none;stroke:#E22336;stroke-dasharray:7,7;}\r\n\t.st7{fill:#E22336;}\r\n\t.st8{font-family:'Montserrat-Medium';}\r\n\t.st9{font-size:13px;}\r\n\t.st10{font-family:'Montserrat-SemiBold';}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.6,32c0.4,0,0.6,0.3,0.6,0.6v178.1h252.1c0.4,0,0.6,0.3,0.6,0.6c0,0.4-0.3,0.6-0.6,0.6H36V32.6 C36,32.3,36.3,32,36.6,32z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115,133.7c-33.9-27.7-64-34.8-78-36.7v114h253v-19c-11.4,0-31.8,0.3-65.9-1.9 C181.6,187.3,151.9,163.9,115,133.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M206,97h84V37c-3.5,0.6-19.4-2.2-41,7.7C222.8,56.6,210,82.7,206,97z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 286,
    cy: 191,
    r: 5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M41.5,98c13.3,2.1,38.6,8.4,74,36C168,175,187,189.5,243,191.5c31.5,1.1,31.1,0.5,46,0.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M40,97.5c30.7,6.2,41.9,14.2,68.5,30.5c27,16.5,56.1,13.8,69.6,6.9C216.6,115,198.4,37,290,37"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M38,97h252"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 113,
    cy: 132,
    r: 5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 37,
    cy: 97,
    r: 5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M113,137v73"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 286,
    cy: 37,
    r: 5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 36,
    cy: 257,
    r: 4
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 36,
    cy: 285,
    r: 4
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 40.9156 42.3808)",
    className: "st8 st9"
  }, "Poids")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 247.3734 225.4169)",
    className: "st8 st9"
  }, "Temps")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 44.7465 261.6132)",
    className: "st7 st10 st9"
  }, "R\xE9gime restrictif")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 44.7467 289.1554)",
    className: "st3 st10 st9"
  }, "R\xE9gime \xE9quilibr\xE9")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehav);
export default __webpack_public_path__ + "static/media/behav.a52fd64426e7d3c7e2a9e00fa4db31f7.svg";
export { ForwardRef as ReactComponent };